"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ThumbnailImage = function ThumbnailImageComponent(_ref) {
  var image = _ref.image,
      index = _ref.index,
      active = _ref.active,
      setSelectedImageindex = _ref.setSelectedImageindex,
      setViewedImageIndex = _ref.setViewedImageIndex;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details__carousel__slide--small".concat(active ? '--active' : ''),
    onClick: function onClick() {
      return setSelectedImageindex(index);
    },
    onKeyPress: function onKeyPress() {
      return setSelectedImageindex(index);
    },
    onMouseEnter: function onMouseEnter() {
      return setViewedImageIndex(index);
    },
    onMouseLeave: function onMouseLeave() {
      return setViewedImageIndex(null);
    },
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "product-details__carousel__preview-image",
    alt: image.alt,
    src: image.url
  }));
};

ThumbnailImage.propTypes = {
  image: _propTypes["default"].shape({
    alt: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired
  }).isRequired,
  index: _propTypes["default"].number.isRequired,
  active: _propTypes["default"].bool.isRequired,
  setSelectedImageindex: _propTypes["default"].func.isRequired,
  setViewedImageIndex: _propTypes["default"].func.isRequired
};
var _default = ThumbnailImage;
exports["default"] = _default;